<template>
    <div class="nav">
        <a v-for="(nav,index) in navList" :key="index" :href="nav.link">
            <p>
                <img :src="nav.icon" alt="">
            </p>
            <p>{{nav.name}}</p>     
        </a>   
    </div>
</template>

<script>
import icon1 from '../../../../assets/images/yundangke/nanning.png'
import icon2 from '../../../../assets/images/yundangke/chongzuo.png'
import icon3 from '../../../../assets/images/yundangke/baise.png'
import icon4 from '../../../../assets/images/yundangke/guilin.png'
import icon5 from '../../../../assets/images/yundangke/hechi.png'
import icon6 from '../../../../assets/images/yundangke/beihai.png'

export default{
    name: 'YNav',
    data(){
        return{
            navList:[
                {link: `#/yundangkelist/${encodeURI('南宁')}/135`, name: '南宁', icon: icon1},
                {link: `#/yundangkelist/${encodeURI('崇左')}/137`, name: '崇左', icon: icon2},
                {link: `#/yundangkelist/${encodeURI('百色')}/138`, name: '百色', icon: icon3},
                {link: `#/yundangkelist/${encodeURI('桂林')}/140`, name: '桂林', icon: icon4},
                {link: `#/yundangkelist/${encodeURI('河池')}/139`, name: '河池', icon: icon5},
                {link: `#/yundangkelist/${encodeURI('北海')}/141`, name: '北海', icon: icon6}

            ]    
        }
    },
    created(){
        
    },
    methods:{
        
    },
    components: {

    }
}
</script>

<style lang="less" scoped>
    .nav{
        padding-top: 0.3rem;
        margin-bottom: 0.3rem;
        background: #fff;
        overflow: hidden;
        border-bottom: 0.2rem solid #f3f3f3;
        a{
            display: block;
            float: left;
            width: 33%;
            text-align: center;
            color: #333;
            font-size: 0.38rem;
            margin-bottom: 0.3rem;
        }
        p{
            &:nth-of-type(1){
                margin-bottom: 0.1rem;
            }
        }
        img{
            width: 50%;
        }
    }          
</style>   